import {
  GET_CUSTOM_FORM_RECORDS,
  GET_CUSTOM_FORM_RECORD,
  CREATE_CUSTOM_FORM_RECORD,
  UPDATE_CUSTOM_FORM_RECORD,
  DESTROY_CUSTOM_FORM_RECORD,
} from "./actions";

// ponytail: always keep id-keyed object — destroy used to _.filter into an array and leave holes
const byId = (records) => _.mapKeys(_.compact(_.isArray(records) ? records : _.values(records)), "id");

export function CustomFormRecordsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_CUSTOM_FORM_RECORDS}_FULFILLED`: {
      return _.merge(byId(state), _.mapKeys(action.payload.data, "id"));
    }
    case `${GET_CUSTOM_FORM_RECORD}_FULFILLED`:
    case `${CREATE_CUSTOM_FORM_RECORD}_FULFILLED`:
    case `${UPDATE_CUSTOM_FORM_RECORD}_FULFILLED`: {
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      if (!id) return state;
      return { ...byId(state), [id]: newItem };
    }
    case `${DESTROY_CUSTOM_FORM_RECORD}_FULFILLED`: {
      const id = _.get(action.payload.data, "id");
      return _.omit(byId(state), [id, String(id)]);
    }
    default:
      return state;
  }
}

// Move this to the reducer page
// import { CustomFormRecordsReducer } from "modules/custom_form/records/reducer"

// custom_form_records:CustomFormRecordsReducer,
